import { createAsyncThunk } from '@reduxjs/toolkit';
import { UserProductsApi } from '@/Api/UserProducts/UserProductsApi';
import { OriginalProductModel } from '@/Models';
import { OriginalProductsApi } from '@/Api/OriginalProducts/OriginalProductsApi';
import { LogisticProduct } from '@/Models/UserProducts/LogisticProduct';
import { GetLogisticCountriesResponse } from '@/Api/Logistics/Responses/GetLogisticCountriesResponse';
import { GetLogisticCountriesRequest } from '@/Api/Logistics/Requests/GetLogisticCountriesRequest';
import { LogisticsApi } from '@/Api/Logistics/LogisticsApi';
import { CreateUserProductResponse } from '@/Api/UserProducts/Responses/CreateUserProductResponse';
import { CreateUserProductRequest } from '@/Api/UserProducts/Requests/CreateUserProductRequest';
import { UpdateUserProductResponse } from '@/Api/UserProducts/Responses/UpdateUserProductResponse';
import { UpdateUserProductRequest } from '@/Api/UserProducts/Requests/UpdateUserProductRequest';

const getAllProductsRequest = createAsyncThunk('userProducts/getProducts', async () => {
  return await UserProductsApi.getProducts();
});

const getLogisticProducts = createAsyncThunk<LogisticProduct[]>('userProducts/logistic-products', async () => {
  return UserProductsApi.getLogisticProducts();
});

const getLogisticCountries = createAsyncThunk<GetLogisticCountriesResponse, GetLogisticCountriesRequest>(
  'userProducts/logistic-countries',
  async (request) => {
    return LogisticsApi.getLogisticCountries(request);
  },
);

const getAllOriginalProductsRequest = createAsyncThunk<OriginalProductModel[]>(
  'userProducts/getOriginalProducts',
  async () => {
    return OriginalProductsApi.getProducts();
  },
);

const createProductRequest = createAsyncThunk<CreateUserProductResponse, CreateUserProductRequest>(
  'userProducts/create-product',
  async (request: CreateUserProductRequest) => {
    return await UserProductsApi.createProduct(request);
  },
);

const updateProductRequest = createAsyncThunk<UpdateUserProductResponse, UpdateUserProductRequest>(
  'userProducts/update-product',
  async (request: UpdateUserProductRequest) => {
    return await UserProductsApi.updateProduct(request);
  },
);

const deleteProductRequest = createAsyncThunk('userProducts/delete-product', async (id: number) => {
  return UserProductsApi.deleteProduct(id);
});

export const userProductsPageAsyncActions = {
  getAllProductsRequest,
  getAllOriginalProductsRequest,
  getLogisticCountries,
  createProductRequest,
  updateProductRequest,
  deleteProductRequest,
  getLogisticProducts,
};
